// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { PublicApi } from '@digitalasset/transfer-instruction-api-ts-client';
import React, { useContext } from 'react';

export const TransferInstructionApiContext = React.createContext<PublicApi | undefined>(undefined);

export const useTransferInstructionApiClient: () => PublicApi = () => {
  const client = useContext<PublicApi | undefined>(TransferInstructionApiContext);
  if (!client) {
    throw new Error('TransferInstruction client not initialized');
  }
  return client;
};
